import React, { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Clickable from 'components/Common/Clickable'
import Heading from 'components/Luxkit/Typography/Heading'
import cn from 'clsx'
import LineAngleRightIcon from 'components/Luxkit/Icons/line/LineAngleRightIcon'
import useToggle from 'hooks/useToggle'
import SlideDown from 'components/Common/SlideDown'
import MarkdownRender from 'components/Luxkit/MarkdownRender'

const Root = styled.div`
  border-bottom: 1px solid ${props => props.theme.palette.neutral.six};
  padding-bottom: 0;
  transition: padding-bottom 0.2s ease;

  &:last-child {
    border-bottom-color: transparent;
  }

  &.is-open {
    padding-bottom: ${rem(16)};

    ${mediaQueryUp.tablet} {
      padding-bottom: ${rem(24)};
    }
  }
`

const SectionHeader = styled(Clickable)`
  display: flex;
  width: 100%;
  padding: ${rem(16)} 0;
  align-items: center;
  justify-content: space-between;

  ${mediaQueryUp.tablet} {
    padding: ${rem(24)} 0;
  }
`

const ArrowContainer = styled.div`
  display: flex;
  justify-content: end;
`

const ArrowIcon = styled(LineAngleRightIcon)`
  transform: rotate(90deg);
  transition: transform 0.2s ease-out;

  &.rotate-180 {
    transform: rotate(-90deg);
  }
`

interface Props {
  inclusion: Tours.V2OfferInclusion
}

function TourV2InclusionSection(props: Props) {
  const { inclusion } = props

  const [open, toggle] = useToggle(false)

  return (
    <Root className={cn({ 'is-open': open })}>
      <SectionHeader onClick={toggle}>
        <Heading variant="heading5">{inclusion.title}</Heading>

        <ArrowContainer>
          <ArrowIcon className={cn({ 'rotate-180': open })} />
        </ArrowContainer>
      </SectionHeader>

      <SlideDown show={open} animateOpacity>
        <MarkdownRender content={inclusion.body} />
      </SlideDown>
    </Root>
  )
}

export default memo(TourV2InclusionSection)
